<template>
  <div style="height: 400px; width: 400px; display: flex; justify-content: center; align-items: center;">
    <button class="circle_btn" @click="addCard"><span style="font-size: 50px; font-weight: lighter">+</span> </button>
  </div>
</template>

<script>
export default {
  name: "AddNewCard",
  inject: ["addNewCardMethod"],
  methods:{
    addCard(){
      this.addNewCardMethod()
    }
  }
}
</script>

<style scoped>
.circle_btn{
  width: 100px;
  height: 100px;
  border-radius:50%;
  background-color: #FFFFFE;
  border: 1px solid #d5d5d5;
  margin: auto;
}
.circle_btn:hover{
  background-color: #dee0e3;
}
.circle_btn:hover span{
  color: blue;
}
</style>
